import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.number-overview',
        itemEmployees: '.number-overview__item--0',
        itemSales: '.number-overview__item--1',
        allcounters: '.number-overview__item-content-number--counter',
        counterEmployees: '.number-overview__item-content-number-counter--0',
        counterSales: '.number-overview__item-content-number-counter--1',
    },
    classNames: {
    },
    dataAttributes: {
        startNumber: 'start',
        endNumber: 'end',
        rounded: 'rounded',
        thousandSeperator: 'thousand-seperator',
        decimalSeperator: 'decimal-seperator',
    }
};

class NumberOverview {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._started = false;
        this.initialized = false;
    }

    init() {
        this._elements = this._getDomElements();

        if (!this._started) {
            this._reveal();
            if (this._reveal()) {
                this._started = true;
            }
        } else {
            this._reset();
            if (this._reset()) {
                this._started = false
            }
        }
        
        this._scrollFunction();
    }

    _getDomElements() {
        return {
            $counterEmployees: this._$rootElement.find(config.selectors.counterEmployees),
            $counterSales: this._$rootElement.find(config.selectors.counterSales),
            $itemEmployees: this._$rootElement.find(config.selectors.itemEmployees),
            $itemSales: this._$rootElement.find(config.selectors.itemSales),
            $animatedItems: this._$rootElement.find('[data-start]'),
        };
    }

    _scrollFunction() {
        $(window).on('scroll', () => {
            if (!this._started) {
                this._reveal();
            } else {
                this._reset();
            }
        });
    }

    _reveal() {
        const elementTop = this._$rootElement.position().top;
        const elementVisible = 30;

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        const viewportMiddle = viewportTop + (viewportBottom - viewportTop) / 2;

        if (viewportMiddle > elementTop - elementVisible && viewportMiddle < elementTop + elementVisible * 20 ) {
            if(!this.initialized) {
                // hide skeleton, show content
                this._$rootElement.find('.ph-row').hide();
                this._elements.$animatedItems.find('span').css('opacity', '1');
                this.initialized = true;
            }

            this._elements.$animatedItems.each((i, el) => {
                const start = $(el).data(config.dataAttributes.startNumber);
                const end = $(el).data(config.dataAttributes.endNumber);
                const decimalSeperator = $(el).data(config.dataAttributes.decimalSeperator);
                const thousandSeperator = $(el).data(config.dataAttributes.thousandSeperator) || '';
                const counter = $(el).find('.number-overview__item-content-number')[0];
     
                if (decimalSeperator) {
                    this._animateValueDecimal(counter, parseFloat(start).toFixed(2), parseFloat(end).toFixed(2), thousandSeperator, decimalSeperator);
                } else {
                    this._animateValueWholeNumbers(counter, parseInt(start), parseInt(end), thousandSeperator);
                }
            });

            this._started = true;
        }
    }

    _reset() {
        const elementTop = this._$rootElement.position().top;
        const elementBotton = elementTop + (this._$rootElement[0].offsetHeight / 2);
        const elementVisibleTop = 700;

        if (window.scrollY < elementTop - elementVisibleTop || window.scrollY > elementBotton) {
            this._elements.$animatedItems.each((i, el) => {
                let targetContainer = $(el)[0].querySelector('.number-overview__item-content-number.odometer');
                let start = $(el).data(config.dataAttributes.startNumber);
                targetContainer.innerHTML = start;
            });
            this._started = false;
        }
    }

    _animateValueDecimal(el, start, end, thousandSeperator, decimalSeperator) {
        // if (start === end) return;
        // el.innerHTML = end;
        
        const range = (end - start);
        let current = Number(start);
        
        const stepTime = 20;
        const countDuration = 600;
        const steps = countDuration / stepTime;
        let increment = (range / steps);

        if(increment < 0.01) {
            increment = 0.01;
        }

        const timer = setInterval(function () {
            current = Number(current) + Number(increment);
            current = Number(parseFloat(current)).toFixed(2);

            if(current > end) {
                current = end;
            }

            const pastThousand = Math.floor(current / 1000) > 0 ? Math.floor(current / 1000) : '';
            const integerPortion = Math.floor(current) - pastThousand * 1000;

            let decimalPortion = Math.floor((current - Math.floor(current)) * 100);
            decimalPortion = decimalPortion === 0 ? '00' : decimalPortion;

            el.innerHTML = '' + pastThousand + thousandSeperator + integerPortion + decimalSeperator + decimalPortion;


            if (current == parseFloat(end)) {
                clearInterval(timer);
            }
        }, stepTime);
    }

    _animateValueWholeNumbers(el, start, end, thousandSeperator) {
        // if (start === end) return;
        // el.innerHTML = end;
        
        const range = end - start;
        let current = start;
        const stepTime = 20;
        const countDuration = 600;
        const steps = countDuration / stepTime;

        const increment = Math.floor(range / steps);

        const timer = setInterval(function () {
            if(current + increment > end) {
                current = end;
            } else {
                (current) += increment;
            }

            if(current >= 1000) {
                el.innerHTML = current.toString().substring(0, 1) + thousandSeperator + current.toString().substring(1);
            } else {
                el.innerHTML =  + current.toString();
                // el.innerHTML = '0,' + current.toString();
            }

            if (current === end) {
                clearInterval(timer)
            }
        }, stepTime);

        
    }
}

moduleRegistry.registerModule('NumberOverview', NumberOverview);
moduleRegistry.autoApplyModule('NumberOverview', config.selectors.root);
